import React from 'react';
import { StandaloneChargeStatusEnum } from '../../../services/standalone-charges';
import { StatusBody, StatusHeading, StatusIcon, StatusMessage, StatusPanel } from '../styles';

type Props = {
  status: StandaloneChargeStatusEnum;
  paidAt?: string;
};

const PaymentStatusView: React.FC<Props> = ({ status, paidAt }) => {
  if (status === StandaloneChargeStatusEnum.paid) {
    return (
      <StatusPanel $kind="success">
        <StatusIcon aria-hidden>✓</StatusIcon>
        <StatusBody>
          <StatusHeading>Pagamento confirmado</StatusHeading>
          <StatusMessage>
            {paidAt
              ? `Recebemos o pagamento em ${new Date(paidAt).toLocaleString('pt-BR')}.`
              : 'Recebemos o pagamento da sua cobrança.'}
          </StatusMessage>
        </StatusBody>
      </StatusPanel>
    );
  }

  if (status === StandaloneChargeStatusEnum.cancelled) {
    return (
      <StatusPanel $kind="warning">
        <StatusIcon aria-hidden>!</StatusIcon>
        <StatusBody>
          <StatusHeading>Cobrança cancelada</StatusHeading>
          <StatusMessage>Esta cobrança foi cancelada e não pode mais ser paga.</StatusMessage>
        </StatusBody>
      </StatusPanel>
    );
  }

  return (
    <StatusPanel $kind="danger">
      <StatusIcon aria-hidden>⏱</StatusIcon>
      <StatusBody>
        <StatusHeading>Prazo encerrado</StatusHeading>
        <StatusMessage>
          O prazo de pagamento foi encerrado. Solicite uma nova cobrança à imobiliária ou a quem
          enviou este link.
        </StatusMessage>
      </StatusBody>
    </StatusPanel>
  );
};

export default PaymentStatusView;
